import { API_URL, getTime } from './_setting.js';
import { titles } from './_title.js';

export let clear = {
	clearTime: 0,
	isRankedIn: false,
	myRank: -1,
	memoryGame: null,
	init: async function( memoryGame, user ){
		clear.memoryGame = memoryGame;
		
		let ms 		= memoryGame.timer.getElapsed();
		const min 	= String(Math.floor(ms / 60000)).padStart(2, "0");
		const sec 	= String(Math.floor((ms % 60000) / 1000)).padStart(2, "0");
		const milli = String(Math.floor(ms % 1000)).padStart(3, "0");
		clear.clearTime = ms;
		let $time = document.querySelector(".c-clear_time");
		$time.setAttribute("data-clear", ms);
		$time.innerHTML = "🕐 " + getTime(ms);
		
		//miss
		let $miss 		= document.querySelector("#b-clear .c-misstime dd span");
		let missTime 	= ( '00' + user.miss ).slice( -2 );
		$miss.innerHTML = missTime;
		
		let $penalty = document.querySelector("#b-clear .c-penalty_time dd");
		$penalty.innerHTML = `05<span class="by">×</span>${user.miss}=<span class="plus">+</span>${5*user.miss}<span class="sec">sec<span>`;
		//$penalty.innerHTML = `05<span class="by">×</span>999=<span class="plus">+</span>${5*999}<span class="sec">sec<span>`;
		
		//称号
		let $title = document.querySelector("#b-clear .c-my_title dd");
		$title.innerHTML = clear.getTitle(ms);
		await clear.checkRanking(ms);
		clear.openClearModal();
		clear.saveToStorage();
	},
	checkRanking: async function(ms){
		try {
			const res = await fetch(API_URL);
			if (!res.ok) return;
			const ranking = await res.json();
			ranking.sort((a, b) => a.time - b.time);
	
			// 10位以内に入れるか判定
			if (ranking.length < 10 || ms < ranking[ranking.length - 1].time) {
				clear.isRankedIn = true;
				// 自分の仮データを挿入
				const myEntry = { name: "???", time: ms, isMe: true };
				ranking.push(myEntry);
				ranking.sort((a, b) => a.time - b.time);
				const top10 = ranking.slice(0, 10);
				clear.myRank = top10.findIndex(r => r.isMe);
				document.querySelector(".c-my_rank p.rank_num").classList.add(`n${clear.myRank}`);
				document.querySelector(".c-my_rank p.rank_num .num").innerHTML = clear.myRank + 1;
				//console.log(top10)
				clear.renderRanking(top10);
			} else {
				document.querySelector(".c-finish").classList.add("norank");
				clear.isRankedIn = false;
				clear.myRank = -1;
				clear.renderRanking(ranking.slice(0, 10));
				
			}
		} catch (e) {
			console.error("通信エラー:", e);
		}
	},
	renderRanking: function(ranking){
		let HTML = "";
		ranking.forEach((r, index) => {
			let meClass = r.isMe ? " is-me" : "";
			let time = "";
			let name = `<dt>${r.name}</dt>`;
			if( r.isMe ){
				time = getTime(clear.clearTime);
				name = `<dt class="js-rankname"></dt>`
			}else{
				time = getTime(r.time);
			}
			HTML += `<li class="rank${index}${meClass}">
						<div class="inr">
							<div class="rank">
								<p class="num">${index + 1}</p>
								<span class="icon_rank"></span>
							</div>
							<dl>
								${name}
								<dd>
									<p class="time">🕐 ${time}</p>
									<p class="title">👑 ${clear.getTitle(r.time)}</p>
								</dd>
							</dl>
						</div>
					</li>`;
		});
		document.querySelector("#ranking ul").innerHTML = HTML;
	},
	openClearModal: function(){
		let $html = document.documentElement;
		$html.classList.add("show_clear");
		setTimeout(function(){
			form.init();
		}, 200);
	},
	closeClearModal: async function(){
		if (!clear.isRankedIn || form.isSent) {
			document.documentElement.classList.remove("show_clear");
			return;
		}
		// ランクイン時はバリデーションを通ったら閉じる
		const success = await form.submit();
		if (success) {
			document.documentElement.classList.remove("show_clear");
		}
	},
	getTitle: function(ms){
		const sec = Math.floor(ms / 1000);
		const title = titles.find(t => sec >= t.start && sec < t.end);
		return title ? title.name : null;
	},
	saveToStorage: function(){
		localStorage.setItem('asl_playCount', (clear.getPlayCount() + 1).toString());
	},
	getPlayCount: function() {
		return parseInt(localStorage.getItem('asl_playCount') || '0', 10);
	}
}

let form = {
	isSent: false,
	label: null,
	init: function(){
		form.target = document.querySelector("#rankingForm");
		if( form.target ){
			form.target = document.querySelector("label#input_name");
			form.nav();
			form.target.querySelector('input[name="name"]').addEventListener('keydown', function(e) {
				if (e.key === 'Enter') {
					e.preventDefault();
				}
			});
		}
	},
	nav: function(){
		let $input = document.querySelector(`#rankingForm input[type="text"]`);
		form.target.addEventListener("click", form.showInput, false);
		const formEl = document.querySelector("form#rankingForm");
		formEl.addEventListener("submit", (e) => e.preventDefault());
		//
		let $backs 	= document.querySelectorAll("[data-back]");
		let $replay = document.querySelectorAll("[data-replay]");
		let $close 	= document.querySelectorAll("[data-modal-close]");
		
		const eventListenersMultiple = [
			{ elements: $backs, type: "click", handler: form.backToTitle },
			{ elements: $replay, type: "click", handler: form.replay },
			{ elements: $close, type: "click", handler: clear.closeClearModal }
		];
		eventListenersMultiple.forEach( ( el ) => {
			el.elements.forEach( ( element )=> {
				element.removeEventListener(el.type, el.handler, false);
				element.addEventListener(el.type, el.handler, false);
			});
		});
		let $nicknames = document.querySelectorAll(".js-nickname");
		//console.log($nicknames);
		$input.addEventListener("input", (e) => {
			e.target.value = e.target.value.replace(/[^\x20-\x7E]/g, "").toUpperCase();
			let arry = e.target.value.split("");
			let $rankName = document.querySelector(".js-rankname");
			if ($rankName) {
				$rankName.innerHTML = e.target.value;
			}
			$nicknames.forEach( ($n ) => {
				$n.querySelectorAll("span").forEach( (s, idx) => {
					let a = arry[idx];
					if( a ){
						s.innerHTML = arry[idx];
					}
				});
			});
		});
		$input.addEventListener("blur", (e) => {
			form.hideInput();
		});
	},
	showInput: function(){
		let $myName = document.querySelector(".c-myname");
		if( !$myName.classList.contains("show_input") ){
			$myName.classList.add("show_input");
		}
	},
	hideInput: function(){
		let $myName = document.querySelector(".c-myname");
		if( $myName.classList.contains("show_input") ){
			$myName.classList.remove("show_input");
		}
	},
	getRanking: async function(){
		try {
			const res = await fetch(API_URL);
			if (!res.ok) return;
			const ranking = await res.json();
			ranking.sort((a, b) => a.time - b.time);
			clear.renderRanking(ranking.slice(0, 10));
		} catch (e) {
			console.error("通信エラー:", e);
		}
	},
	backToTitle: async function(e){
		e.preventDefault();
		const success = await form.submit();
		if (success) {
			// タイトルに戻る処理
			location.href = "/";
		}
	},
	replay: async function(e){
		e.preventDefault();
		const success = await form.submit();
		if (success) {
			location.href = "/?type=replay";
			/*
			clear.memoryGame.reset();
			setTimeout(function(){
				clear.closeClearModal();
				form.reset();
			}, 100);
			*/
		}
	},
	reset: function(){
		document.querySelector(`#rankingForm input[type="text"]`).value = "";
		let $nicknames = document.querySelectorAll(".js-nickname");
		$nicknames.forEach( ($n ) => {
			$n.querySelectorAll("span").forEach( (s, idx) => {
				s.innerHTML = "";
			});
		});
		document.querySelector(".c-time dd.progress .js-time").innerHTML = "00:00:000";
		document.querySelector(".c-my_rank p.rank_num").classList.remove(`n${clear.myRank}`);
		document.querySelector(".c-my_rank p.rank_num .num").innerHTML = "";
		document.querySelector(".c-finish").classList.remove("norank");
	},
	submit: async function(){
		if( !form.isSent ){
			const formEl = document.querySelector("form#rankingForm");
			let name 	= formEl.name.value;
			//console.log(name);
			if( name ){
				name 		= name.toUpperCase();
				const time = parseFloat( clear.clearTime );
				if (name.length !== 3 || /[^\x20-\x7E]/.test(name)) {
					alert("名前は半角3文字で入力してください");
					return false;
				}
				try {
					const res = await fetch(API_URL, {
						method: "POST",
						headers: { "Content-Type": "application/json" },
							body: JSON.stringify({ name, time }),
						});
					if (res.ok) {
						form.isSent = true;
						console.log("登録しました。");
						//document.querySelector(".c-finish").remove();
						//form.getRanking();
						return true;
					} else {
						console.error("登録失敗:", res.status);
						return false;
					}
				} catch (e) {
					alert("通信エラーが起きました。もう一度やり直してください。");
					return false;
				}
			}else{
				return true;
			}
		}
		return true;
	}
}

